import { Injectable, OnInit } from "@angular/core";

@Injectable({ providedIn: "root" })
export class StatusTranslatorService {

  statuses: Map<string, string>;

  constructor() {
    this.statuses = new Map<string, string>();
    this.statuses.set("AWAITING_DOZ_DISTRIBUTION", "Очікує рішення");
    this.statuses.set("DRAFT", "Чернетка");
    this.statuses.set("PENDING_APPROVAL", "На погодженні");
    this.statuses.set("COMPLETED", "Виконано");
    this.statuses.set("ARCHIVED", "Архівовано");
    this.statuses.set("SUPPLY_STATUS_PARTIALLY_APPROVED", "Часткове підтвердження");
  }

  getStatusForString(text: string): string {
    return this.statuses.get(text) || "";
  }
}
